'use client';

import { BaseMarketingSection } from '@/components/organisms';
import { BaseMarketingSectionSkeleton } from '@/components/organisms/skeletons/BaseMarketingSectionSkeleton';
import { useMarketingInfoQuery } from '@/hooks/league/useMarketingInfoQuery';

export const PartnersSection = () => {
	const { data: partnersSectionInfo, isFetching } = useMarketingInfoQuery('3');
	const modules = partnersSectionInfo?.data?.modules;
	if (isFetching) {
		return <BaseMarketingSectionSkeleton />;
	}

	if (!modules || modules.length === 0) {
		return null;
	}

	return <BaseMarketingSection marketingData={modules ?? []} marketingTitle="Partners" />;
};
